<template>
  <div>
    <v-flex xs12>
      <v-text-field v-model="clau" :label="$t('Clau')"></v-text-field>
    </v-flex>
    <div class="text-xs-right">
      <v-btn color="success" @click="guardar">{{ $t("Acceptar") }}</v-btn>
    </div>
    <v-alert :value="error" type="error">{{ $t("Clau_incorrecta") }}</v-alert>
  </div>
</template>

<script>
import axios from "axios";
import api from "../api.js";
import Cookies from "js-cookie";

export default {
  data: () => ({
    clau: "",
    error: false,
  }),
  created() {
    axios
      .post(api.URL() + "/api/v1/token", { token: Cookies.get("st3token") })
      .then((response) => {
        if (response.data == "OK") this.$router.push("/");
      });
  },
  methods: {
    guardar() {
      if (this.clau != "") {
        Cookies.set("st3token", this.clau, { expires: 8000 });
        axios
          .post(api.URL() + "/api/v1/token", { token: Cookies.get("st3token") })
          .then((response) => {
            if (response.data == "OK") this.$router.push("/");
          });
      }
    },
  },
};
</script>
